<template>
  <v-dialog v-model="localShow" max-width="600px" persistent>
    <v-card>
      <v-card-title class="primary white--text">
        {{ isEdit ? $t('edit_agreement') : $t('create_agreement') }}
      </v-card-title>

      <v-card-text class="pa-6">
        <v-form ref="form" @submit.prevent="handleSubmit">
          <h4 class="mb-4">{{ $t('field_name') }}</h4>

          <v-text-field
            v-model="form.name"
            :label="$t('field_name')"
            outlined
            dense
            required
            :rules="[rules.required]"
            class="mb-4"
          ></v-text-field>

          <v-text-field
            v-model="form.location"
            :label="$t('field_location')"
            outlined
            dense
            required
            :rules="[rules.required]"
            class="mb-4"
          ></v-text-field>

          <v-text-field
            v-model="form.phone"
            :label="$t('field_phone')"
            outlined
            dense
            required
            :rules="[rules.required]"
            class="mb-4"
          ></v-text-field>

          <v-select
            v-model="form.agreement_type"
            :label="$t('agreement_type')"
            :items="agreementTypes"
            item-text="text"
            item-value="value"
            outlined
            dense
            required
            :rules="[rules.required]"
            class="mb-6"
          ></v-select>

          <v-divider class="mb-6"></v-divider>

          <h4 class="mb-4">{{ $t('coordinator') }}</h4>

          <v-text-field
            v-model="form.coordinator_name"
            :label="$t('coordinator_name')"
            outlined
            dense
            required
            :rules="[rules.required]"
            class="mb-4"
          ></v-text-field>

          <v-text-field
            v-model="form.coordinator_email"
            :label="$t('coordinator_email')"
            type="email"
            outlined
            dense
            required
            :rules="[rules.required, rules.email]"
            class="mb-4"
          ></v-text-field>

          <v-text-field
            v-model="form.coordinator_phone"
            :label="$t('coordinator_phone')"
            outlined
            dense
            required
            :rules="[rules.required]"
            class="mb-6"
          ></v-text-field>

          <v-divider class="mb-6"></v-divider>

          <h4 class="mb-4">{{ $t('field_validity') }}</h4>

          <v-row>
            <v-col cols="12" sm="6">
              <v-text-field
                v-model="form.valid_from"
                :label="$t('valid_from')"
                type="date"
                outlined
                dense
                required
                :rules="[rules.required]"
              ></v-text-field>
            </v-col>
            <v-col cols="12" sm="6">
              <v-text-field
                v-model="form.valid_until"
                :label="$t('valid_until')"
                type="date"
                outlined
                dense
                required
                :rules="[rules.required]"
              ></v-text-field>
            </v-col>
          </v-row>

          <v-alert
            v-if="error"
            type="error"
            dismissible
            class="mt-4"
          >
            {{ error }}
          </v-alert>
        </v-form>
      </v-card-text>

      <v-divider></v-divider>

      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn text @click="closeDialog">
          {{ $t('cancelar') }}
        </v-btn>
        <v-btn
          color="primary"
          :loading="submitting"
          @click="$refs.form.validate() && handleSubmit()"
        >
          {{ isEdit ? $t('guardar') : $t('crear') }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: 'CourseAgreementForm',
  props: {
    show: {
      type: Boolean,
      default: false
    },
    agreement: {
      type: Object,
      default: null
    }
  },
  data () {
    return {
      form: {
        name: '',
        location: '',
        phone: '',
        agreement_type: 2,
        coordinator_name: '',
        coordinator_email: '',
        coordinator_phone: '',
        valid_from: '',
        valid_until: ''
      },
      error: null,
      submitting: false,
      rules: {
        required: v => !!v || this.$t('required_field'),
        email: v => {
          const pattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/
          return pattern.test(v) || 'Email debe ser válido'
        }
      },
      agreementTypes: [
        { text: this.$t('agreement_type_pago'), value: 1 },
        { text: this.$t('agreement_type_cortesia'), value: 2 },
        { text: this.$t('agreement_type_intercambio'), value: 3 },
        { text: this.$t('agreement_type_privilegio'), value: 4 },
        { text: this.$t('agreement_type_especial'), value: 5 }
      ]
    }
  },
  computed: {
    localShow: {
      get () {
        return this.show
      },
      set (value) {
        if (!value) {
          this.closeDialog()
        }
      }
    },
    isEdit () {
      return !!this.agreement
    }
  },
  watch: {
    show (newVal) {
      if (newVal) {
        this.loadFormData()
      }
    }
  },
  methods: {
    loadFormData () {
      if (this.agreement) {
        this.form = {
          name: this.agreement.name,
          location: this.agreement.location,
          phone: this.agreement.phone,
          agreement_type: this.agreement.agreement_type,
          coordinator_name: this.agreement.coordinator_name,
          coordinator_email: this.agreement.coordinator_email,
          coordinator_phone: this.agreement.coordinator_phone,
          valid_from: this.agreement.valid_from,
          valid_until: this.agreement.valid_until
        }
      } else {
        this.resetForm()
      }
      this.error = null
    },
    resetForm () {
      this.form = {
        name: '',
        location: '',
        phone: '',
        agreement_type: 2,
        coordinator_name: '',
        coordinator_email: '',
        coordinator_phone: '',
        valid_from: '',
        valid_until: ''
      }
    },
    async handleSubmit () {
      if (!this.$refs.form.validate()) {
        return
      }

      this.submitting = true
      this.error = null

      try {
        this.$emit('submit', this.form)
      } catch (err) {
        this.error = err.message
      } finally {
        this.submitting = false
      }
    },
    closeDialog () {
      this.$emit('close')
    }
  }
}
</script>

<style scoped lang="scss">
h4 {
  font-size: 14px;
  font-weight: 600;
  color: #333;
  text-transform: uppercase;
}
</style>
